import React, { memo, useCallback } from 'react'
import { Route, RouteComponentProps, RouteProps } from 'react-router-dom'
import { SuspenseComponent } from 'Modules'

export type LazyRouteProps = Omit<RouteProps, 'component' | 'render' | 'element' | 'children'> & {
	lazyComponent: ReturnType<typeof React.lazy>
}

export const LazyRoute = memo<LazyRouteProps>(
	({ lazyComponent: LazyComponent, ...props }): JSX.Element => {
		const Component = useCallback(
			(routeComponentProps: RouteComponentProps) => (
				<SuspenseComponent>
					<LazyComponent {...routeComponentProps} />
				</SuspenseComponent>
			),
			[LazyComponent]
		)
		return <Route {...props} component={Component} />
	}
)
